import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/app/context/AuthContext";
import { ChesslaLoadingMark } from "@/shared/components/ChesslaLoadingMark";
import { safeReturnPath } from "@/features/auth/auth-navigation";

/**
 * Layout wrapper for guest-only routes (login, signup).
 * Redirects authenticated users to their requested destination or Home.
 */
export const GuestLayout = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const { search } = useLocation();

  if (isLoading) {
    return <ChesslaLoadingMark fullScreen label="Opening Chessla" />;
  }

  if (isAuthenticated) {
    return <Navigate to={safeReturnPath(search) ?? "/home"} replace />;
  }

  return <Outlet />;
};
